import React from 'react';
import PropTypes from 'prop-types';
import * as Styled from '../../Footer.styles';
import GridItem from './GridItem';

var Grid = function Grid(_ref) {
  var grid = _ref.grid;
  return /*#__PURE__*/React.createElement(Styled.SecondaryFooter, {
    className: "xs-row"
  }, grid.map(function (_ref2) {
    var title = _ref2.title,
        component = _ref2.component;
    return /*#__PURE__*/React.createElement(Styled.SecondaryFooterColumn, {
      key: title,
      className: "xs-12-none md-6"
    }, /*#__PURE__*/React.createElement(GridItem, {
      title: title
    }, component));
  }));
};

Grid.propTypes = {
  grid: PropTypes.arrayOf(PropTypes.shape({
    title: PropTypes.string.isRequired,
    component: PropTypes.object.isRequired
  })).isRequired
};
export default Grid;